<template lang="pug">
  .atu.objects
    e-toolbar(
      :hideRemoveButton="true"
      :showViewPanel="false"
      :showTotal="true"
      :items="items"
      :hideImportBtn="true"
      :showResetSortBtn="true"
      :showExport="true"
      :hideAddButton="hideAddButton"
      :hasTariffYearSelect="true"
      :endpointExport="endpointExport()"
      @changeTariffYearSelect="changeTariffYearSelect"
    )
      .parameter.parameter--right(slot="searchResult" v-if='hasAtuGroup')
          router-link.reset-btn.button(:to="{name:'atu.groupObjects'}") Группировать
    // cuscroll disabled
    // because reset page scroll postion after each table update
    e-table(
      tableWrapperClass="table"
      :items="items"
      @editItem="editItem"
      :showDeleteButton="false"
      :showCheckbox="false"
      :actionColumnWidth="150"
      :tableUpdate="tableUpdate"
    )
      template(slot="name" slot-scope="props")
        div(v-if="props.row.has_children")
          div(
            v-if="!isOpened(props.row)"
            :class="getItemClass(props.row)"
            @click.stop.prevent="openChild(props.row)"
          ).item.with-actions.closed.table__item
            button.arrow.reset-btn.table__arrow
            span {{props.row.name}}
          div(
            v-else
            :class="getItemClass(props.row)"
            @click.stop.prevent="closeChild(props.row)"
          ).item.with-actions.opened
            button.arrow.reset-btn.arrow_opened.table__arrow
            span {{props.row.name}}
        div(
          v-else
          :class="getItemClass(props.row)"
        ).item
          span {{props.row.name}}

      div(slot="actionButtons" slot-scope="props").actions
        button.row-add.reset-btn.button.button_small.button_create.button_icon(
          v-if="props.acceptCreate"
          @click.stop.prevent="createItem(props.row)"
        )
        button.row-edit.reset-btn.button.button_edit.button_small.button_icon(
          v-if="props.acceptEdit"
          @click.stop.prevent="editItem(props.row)"
        )
        button.row-view(
          v-else-if="props.displayViewButton"
          @click.stop.prevent="editItem(props.row)"
        ) {{$translate('Открыть')}}
        button.row-delete.reset-btn.button.button_small.button_delete.button_icon(
          v-if="props.acceptDelete"
          @click.stop.prevent="deleteItem(props.row)"
        )

    router-view
</template>

<script>
import { atu, export_document } from '@/api/api-endpoints'
import url from '@/utils/url'
import year from '@/utils/year'
import RouteMixin from '@/mixins/route-mixin'
import hasMixin from '@/mixins/has-mixin'
import objectsMixin from './mixins/objects-mixin'

const DEFAULT_YEAR = year.getCurrentYear()

export default {
  mixins: [objectsMixin, RouteMixin, hasMixin],
  data() {
    return {
      year: DEFAULT_YEAR,
    }
  },
  computed: {
    hideAddButton() {
      return this.$route.meta?.hasSort
    },
  },
  watch: {
    $route: 'onRoute',
  },
  methods: {
    createItem(item) {
      let query = {
        prevRoute: url.getRoute(this.$route, true),
        setFields: JSON.stringify({
          parent_id: item.id,
        }),
      }
      this.$router.push({
        name: this.$route.name + '.create',
        query,
      })
    },
    endpointExport() {
      return export_document.geo(this.$route)
    },
    getDeleteUrl(id) {
      return atu.atuObjectDelete(id)
    },
    getEndpoint(route) {
      if (route.meta?.hasSort) {
        route.query.has_sort = 1
      } else {
        route.query.has_sort = -1
      }
      route.query.year = this.year ? this.year : year.getCurrentYear()
      return atu.atuObjects(route)
    },
    changeTariffYearSelect(year) {
      this.year = year
      this.replaceRoute({ year }, false)
      this.getData()
    },
    async getData() {
      this.$bar.start()
      await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: this.getEndpoint(this.$route),
      })
      this.$bar.finish()
    },
  },
}
</script>
